<template>
  <div class="home-page">
    <div class="home-inner">
      <Row class="row-item top-row">
        <!--常用菜单 这里使用v-if主要防止servers还没有加载出来-->
        <Col span="24" class-name="row-col">
          <menus-card>
            <drop-item slot="extra" :item-type="0"></drop-item>
          </menus-card>
          <br style="clear: both" />
        </Col>
        <new-promotion></new-promotion>
      </Row>
      <!--<iframe src="http://dev.ovopark.com/grafana/d/r6m1ypt7k/diaohuitest?orgId=1&from=1638498571390&to=1638520171390&kiosk"
              frameborder="0"
              width="100%"
              id="myiframe"
              scrolling="no"
              @onload="changeFrameHeight()"
              allowtransparency
      ></iframe>-->
      <Row class="row-item board-item">
        <!--近７日数据看板-->
        <!-- <Col span="24">
          <board-card></board-card>
        </Col> -->
      </Row>
      <div class="config-bar">
        <!-- <system-tip
          tip-id="modulesTip"
          :content="$t('home.tip_modulesconfig')"
          class="modules-systemtip"
        ></system-tip> -->
        <div class="config-left">
          {{ $t('common.data_show') }}
        </div>
        <div class="open-big" @click="onConfig">
          <img src="../../../public/images/home/ico_setup@2x.png" alt="" />
        </div>
        <div class="open-big" @click="toggle">
          <img src="../../../public/images/home/open-big.png" alt="" />
        </div>
        <!-- <div class="config-btn" @click="onConfig">
          <i class="iconfont icon-newicon-xitongshezhi"></i
          ><span class="config-text">{{ $t('home.card_config') }}</span>
        </div> -->
      </div>

      <fullscreen
        v-model="fullscreen"
        class="data-charts-box"
        ref="dataChartsBox"
      >
        <!-- 非全屏模式下展示 -->
        <div class="not-full-screen" v-if="!fullscreen">
          <draggable
            class="cards-container"
            :class="{ active: fullscreen }"
            @end="dragEnd"
            v-model="newModules"
          >
            <!--root账号不显示数据中心-->
            <div
              class="card-item"
              v-for="item in newModules"
              :class="item.tagCompontentName"
              :key="item.id"
              v-show="!(isRoot && item.id === -13)"
            >
              <component
                :is="getComponent(item.tagCompontentName)"
                :tag="item"
                :ref="'card-' + item.tagCompontentName"
              >
                <p slot="title">{{ item.tagName }}</p>
                <drop-item
                  slot="extra"
                  :item-type="1"
                  :modules="newModules"
                  :item-data="item"
                  @refresh="refreshList"
                ></drop-item>
              </component>
            </div>
            <div
              class="card-item"
              v-for="index of emptyModules"
              :key="index"
              v-show="!moreDataCharts"
            >
              <Card></Card>
            </div>
          </draggable>
        </div>
        <!-- 全屏模式下展示 -->
        <div
          @mousemove="handleMousemove"
          class="full-screen"
          v-if="fullscreen"
          :style="{ 'background-image': `url(${backgroundUrl})` }"
        >
          <div class="top-screen">
            <div class="big-left">
              <img :src="$system.$state.enterpriseInfo.logoPath" alt="" />
              <p>{{ bigbBcreenTitle }}</p>
            </div>
            <div class="big-right">
              <div class="control-wrapper" ref="control-wrapper">
                <div class="swiper-control">
                  <div class="control-btn swiper-control-left" @click="preUp">
                    <Icon type="ios-arrow-back" color="#FFFFFF" />
                  </div>
                  <div class="swiper-control-num">
                    {{ carouselValue + 1 + '/' + swiperList.length }}
                  </div>
                  <div
                    class="control-btn swiper-control-right"
                    @click="preNext"
                  >
                    <Icon type="ios-arrow-forward" color="#FFFFFF" />
                  </div>
                  <div class="control-btn" @click="autoplay = !autoplay">
                    <img
                      style="width: 16px; height: 16px"
                      :src="controlAutoplayIcon"
                      alt=""
                    />
                  </div>
                </div>
                <div class="control-btn" @click="toggle">
                  <img
                    src="../../../public/images/home/exitfullscreen.png"
                    alt=""
                  />
                </div>
              </div>
              <p>
                {{ currentDate }}
              </p>
            </div>
          </div>
          <Carousel
            v-model="carouselValue"
            style="height: 100%"
            arrow="never"
            :autoplay="autoplay"
            :autoplay-speed="60000"
          >
            <CarouselItem
              v-for="(itemModule, index) in swiperList"
              :key="index"
              style="height: 100%"
            >
              <draggable
                class="cards-container"
                :class="{ active: fullscreen }"
                @end="dragEnd('full')"
                v-model="swiperList[index]"
              >
                <!--root账号不显示数据中心-->
                <div
                  class="card-item"
                  v-for="item in itemModule"
                  :class="item.tagCompontentName"
                  :key="item.id"
                  v-show="!(isRoot && item.id === -13)"
                >
                  <component
                    :is="getComponent(item.tagCompontentName, '-big')"
                    :tag="item"
                    :ref="'big-' + item.tagCompontentName"
                  >
                    <p slot="title">{{ item.tagName }}</p>
                    <drop-item
                      slot="extra"
                      :item-type="1"
                      :modules="itemModule"
                      :item-data="item"
                      @refresh="refreshList"
                    ></drop-item>
                  </component>
                </div>
              </draggable>
            </CarouselItem>
          </Carousel>
        </div>
        <div class="more-data-box" v-show="!moreDataCharts && !fullscreen">
          <div @click="showMoreDataCharts">
            <i
              class="iconfont"
              :class="[!moreDataCharts ? 'icon-moreunfold' : 'icon-less']"
            ></i
            >{{ $t('home.view_more') }}
          </div>
        </div>
      </fullscreen>
      <cards-config
        @on-close="onCardConfigClose"
        @refresh="refreshList"
        :modules="allModules"
        :show-modal="display.showCardConfig"
        :backgroundIndexProp="backgroundIndex"
        :name="bigbBcreenTitle"
      ></cards-config>
    </div>
  </div>
</template>

<script>
import draggable from 'vuedraggable';
import MenusCard from './cards/menus-card.vue';
import DropItem from './components/drop-item.vue';
import CardsConfig from './components/cards-config.vue';
import SystemTip from '../../components/system-tip.vue';
import api from '../../api/home';
import wcc from 'wdz-common-components';
const utils = wcc.utils;
import { filterTags } from './dataFilter';
import moment from 'moment';
import NewPromotion from './components/new-promotion.vue';
//import { getLanguage } from 'wdz-common-components/src/common/js/ovoSystem';
const colNumOfRow = 2; //每行２个col
import { mapCatch } from '../../api/request';

export default {
  name: 'home',
  components: {
    SystemTip,
    draggable,
    MenusCard,
    DropItem,
    CardsConfig,
    NewPromotion,
  },
  data() {
    return {
      swiperList: [],
      carouselValue: 0,
      colNumOfRow: colNumOfRow, //列数
      modules: [],
      rows: [],
      emptyModules: 3,
      display: {
        showCardConfig: false,
      },
      fullscreen: false, // 是否全屏
      currentDate: null,
      timerUpdata: null,
      // bigLogo:
      //   getLanguage() == 'zh-CN' || getLanguage() == 'zh-TW'
      //     ? require('../../../public/images/home/logo-big.png')
      //     : require('../../../public/images/home/icon_big_en.png'),
      backgroundUrl: '',
      backgroundIndex: null,
      timerId: null,
      isMousemove: false,
      moreDataCharts: false,
      newModules: [],
      autoplay: false,
      bigbBcreenTitle: '',
    };
  },
  watch: {
    fullscreen(val) {
      clearInterval(this.timerUpdata);
      //设置保持长期会话/取消长期会话标识
      if (val) {
        this.isMousemove = false;
        this.updataInfos();
        // eslint-disable-next-line no-undef
        ccutils.setNeedLongSession();
      } else {
        // eslint-disable-next-line no-undef
        ccutils.removeNeedLongSession();
      }
    },
    swiperList: {
      handler(val) {
        let modules = [];
        val.forEach(swiper => {
          swiper.forEach(s => {
            modules.push(s);
          });
        });
        if (this.moreDataCharts) {
          this.newModules = modules;
        } else {
          this.newModules = modules.slice(0, this.emptyModules);
        }
      },
      deep: true,
    },
    moreDataCharts: {
      handler() {
        let modules = [];
        this.swiperList.forEach(swiper => {
          swiper.forEach(s => {
            modules.push(s);
          });
        });
        if (this.moreDataCharts) {
          this.newModules = modules;
        } else {
          this.newModules = modules.slice(0, this.emptyModules);
        }
      },
      deep: true,
    },
  },
  computed: {
    servers() {
      return this.$system.$state.servers;
    },
    isRoot() {
      return (
        this.$system.$state.baseInfo.isSuper &&
        !this.$system.$state.baseInfo.data.groupId
      );
    },
    allModules() {
      let modules = [];
      this.swiperList.forEach(swiper => {
        swiper.forEach(s => {
          modules.push(s);
        });
      });
      return modules;
    },
    controlAutoplayIcon() {
      return this.autoplay
        ? require('../../../public/images/home/swiper.png')
        : require('../../../public/images/home/no_swiper.png');
    },
  },
  created() {
    this.componentMap = {};
    // console.log(this.$system.$state.enterpriseInfo,'enterpriseInfo')
    this.getModules();
    ccutils.buriedPonitUpload({ key: 'WEB_HOME', id: '-1', pageCode: '01-01-w-005' });
  },
  mounted() {
    clearInterval(t);
    let t = setInterval(() => {
      let date = moment().format('YYYY-MM-DD HH:mm:ss');
      // 因为moment走夏令时，而后台逻辑不考虑夏令时，所以前端页面时间比后台创建的任务时间会快一个小时
      // 判断当前时区此时是否是夏令时，是就减一个小时，来和后台保持一致
      const isDST = moment().isDST();
      if (isDST) {
        date = moment(date).subtract(1, 'hours').format('YYYY-MM-DD HH:mm:ss');
      }
      this.currentDate = date;
    }, 1000);
    /*  this.changeFrameHeight();
    window.onresize = () => {
      this.changeFrameHeight();
      this.dynamicSetData();
    }; */
    // 获取 .home-page 元素
    const homePage = document.querySelector('.home-page');

    // 创建 ResizeObserver 实例
    const observer = new ResizeObserver(() => {
      this.changeFrameHeight();
      this.dynamicSetData();
    });

    // 监听 .home-page 元素的大小变化
    observer.observe(homePage);
  },
  methods: {
    getComponent(name, big = '') {
      const prop = name + big;
      if (this.componentMap[prop]) {
        return this.componentMap[prop];
      }
      const syncImport = () => import(`./cards${big}/${name}.vue`);
      this.componentMap[prop] = syncImport;
      return syncImport;
    },
    /**
     * 根据宽度动态设置更多数据提示位置
     */
    dynamicSetData() {
      let width = this.$refs.dataChartsBox.$el.offsetWidth;
      if (width > 1265) {
        this.emptyModules = 3;
      }
      if (width < 1265) {
        this.emptyModules = 2;
      }
      if (width < 730) {
        this.emptyModules = 1;
      }
    },
    showMoreDataCharts() {
      this.moreDataCharts = !this.moreDataCharts;
    },
    preUp() {
      if (this.carouselValue > 0) {
        this.carouselValue--;
      }
    },
    preNext() {
      if (this.carouselValue + 1 < this.swiperList.length) {
        this.carouselValue++;
      }
    },
    handleMousemove() {
      if (this.isMousemove) return;
      clearTimeout(this.timerId);
      this.isMousemove = true;
      this.$refs['control-wrapper'].style = 'visibility: inherit';
      this.timerId = setTimeout(() => {
        if (this.$refs['control-wrapper']) {
          this.$refs['control-wrapper'].style = 'visibility: hidden';
          this.isMousemove = false;
        }
      }, 3000);
    },
    changeFrameHeight() {
      let ifm = document.getElementById('myiframe');
      ifm && (ifm.height = document.documentElement.clientHeight);
      this.modules.forEach(item => {
        let refName = 'card-' + item.tagCompontentName;
        let bigRefName = 'big-' + item.tagCompontentName;
        let cardComponent = this.$refs[refName];
        let bigCardComponent = this.$refs[bigRefName];
        if (
          cardComponent &&
          cardComponent[0] &&
          cardComponent[0].myEchartsResize
        ) {
          cardComponent[0].myEchartsResize();
        }
        if (
          bigCardComponent &&
          bigCardComponent[0] &&
          bigCardComponent[0].myEchartsResize
        ) {
          bigCardComponent[0].myEchartsResize();
        }
      });
    },
    //获取首页我的模块
    getModules() {
      let modules1 = {
        allChildShops: [],
        childTagCount: 0,
        childTags: [],
        departments: [],
        enterpriseId: null,
        id: -1001,
        isDelete: 0,
        isPublic: 1,
        isShop: null,
        logoUrl: null,
        parentId: null,
        parentName: null,
        pinyin: "",
        shopCount: 0,
        shops: [],
        sort: null,
        tagName: "门店类型",
        tagType: 1001,
      }
      let modules2 = {
        allChildShops: [],
        childTagCount: 0,
        childTags: [],
        departments: [],
        enterpriseId: null,
        id: -1002,
        isDelete: 0,
        isPublic: 1,
        isShop: null,
        logoUrl: null,
        parentId: null,
        parentName: null,
        pinyin: "",
        shopCount: 0,
        shops: [],
        sort: null,
        tagName: "进店客流日均值",
        tagType: 1002,
      };
      api
        .getModules()
        .then(res => {
          if(this.$system.$state.baseInfo.data.groupId === 4981){
            if(res.data&&res.data.enterpriseTags){
              res.data.enterpriseTags.unshift(modules1);
              res.data.enterpriseTags.splice(3,0,modules2);
            }
          }
          //把tagType为0的模块以极消息模块过滤掉，不展示
          this.backgroundUrl = res.data.backgroundUrl;
          this.backgroundIndex = res.data.backgroundIndex;
          this.bigbBcreenTitle = res.data.name || this.$t('common.big_screen');
          this.modules = filterTags(res.data.enterpriseTags);
          //root账号不显示数据中心
          this.modules = this.modules.filter(item => {
            return !(item.id == -13 && this.isRoot);
          });
          this.rows = [];
          let arr = this.modules;
          let result = [];
          for (let i = 0; i < arr.length; i += 9) {
            result.push(arr.slice(i, i + 9));
          }
          let modules = [];
          result.forEach(swiper => {
            swiper.forEach(s => {
              modules.push(s);
            });
          });
          if (modules.length < 4) {
            this.moreDataCharts = true;
          }
          this.swiperList = result;
          this.dynamicSetData();
          //一行显示２个,计算需要的行数
          /*if (this.modules.length > 0) {
            this.modules.reduce((rows, item, index, modules) => {
              if (index % this.colNumOfRow === 0) {
                this.rows.push(modules.slice(index, index + this.colNumOfRow));
              }
              return this.rows;
            }, this.rows);
          }*/
        })
        .catch(error => {
          this.$Message.error(
            `${this.$t('home.error_getusermodule')}：${error}`
          );
        });
    },
    refreshList() {
      this.getModules();
    },
    dragEnd(type) {
      let params = '';
      if (type === 'full') {
        let modules = [];
        this.swiperList.forEach(swiper => {
          swiper.forEach(s => {
            modules.push(s);
          });
        });
        params = utils.getAttributesStrFromArray(modules);
      } else {
        let modules = [];
        if (this.newModules.length === this.modules) {
          modules = this.newModules;
        } else {
          let tempArr = this.modules.slice(this.newModules.length);
          modules = [...this.newModules, ...tempArr];
        }
        let result = [];
        for (var i = 0; i < modules.length; i += 9) {
          result.push(modules.slice(i, i + 9));
        }

        this.swiperList = result;
        params = utils.getAttributesStrFromArray(modules);
      }
      this.saveUserShopTagsApi(params);
    },
    saveUserShopTagsApi(params) {
      api
        .saveUserShopTags({
          tagIds: params,
        })
        .catch(error => {
          console.error(error);
        });
    },
    onConfig() {
      this.display.showCardConfig = true;
    },
    onCardConfigClose() {
      this.display.showCardConfig = false;
    },
    toggle() {
      // 判断大屏展示的模块数量是否超过9个
      // const canBigShowNum = Object.values(this.$refs).filter(val=>val.length > 0)
      // if(canBigShowNum.length > 9) {
      //    this.$Message.error(this.$t('home.can_not_show_big'));
      // } else {
      this.fullscreen = !this.fullscreen;
      this.carouselValue = 0;
      //}
    },
    // 更新各个图表的数据
    updataInfos() {
      mapCatch.clear();
      this.timerUpdata = setInterval(() => {
        mapCatch.clear();
        // 过滤出有内容的
        const allInfos = Object.values(this.$refs).filter(
          val => val.length > 0
        );
        for (let index = 0; index < allInfos.length; index++) {
          allInfos[index][0].getData();
        }
      }, 1000 * 60 * 60);
    },
  },
};
</script>
<style>
.ivu-carousel-list {
  height: 100%;
}

.ivu-carousel-track {
  height: 100%;
}
</style>
<style lang="scss" type="text/scss">
@import 'home';
</style>
